import { render } from "./RequestsIndex.vue?vue&type=template&id=04f13e32"
import script from "./RequestsIndex.vue?vue&type=script&lang=js"
export * from "./RequestsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__